import script from "./banmian.vue?vue&type=script&setup=true&lang=js"
export * from "./banmian.vue?vue&type=script&setup=true&lang=js"

import "./banmian.vue?vue&type=style&index=0&id=08a78d05&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a78d05"]])

export default __exports__